import React from 'react'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '~/lib/ui/table'
import Pagination from './Pagination'
import { useCandidate } from './CandidateProvider'
import { useCandidateActivity } from './CandidateActivitySection'
import { useFormatTime } from '~/hooks/useFormatTime'
import { useTranslation } from '~/hooks/useTranslation'

const PAGE_SIZE = 50

const ActivityLog = () => {
  const { t } = useTranslation('ActivityLog')
  const { candidate } = useCandidate()
  const { candidateActivities } = useCandidateActivity()
  const [page, setPage] = React.useState(1)
  const total = candidateActivities?.length || 0

  // Paginate activities
  const paginated = React.useMemo(() => {
    if (!candidateActivities) return []
    const start = (page - 1) * PAGE_SIZE
    return candidateActivities.slice(start, start + PAGE_SIZE)
  }, [candidateActivities, page])

  return (
    <>
      <div className="mb-4">
        <span className="font-bold">{t('total_points')}</span>{' '}
        {candidate.activityPoints}
      </div>
      <Table
        className="w-full border-separate"
        tableClass="w-full rounded-2xl border border-silver"
      >
        <ActivityHeading />
        <TableBody>
          {paginated.map((candidateActivity) => (
            <ActivityRow
              key={`candidate-activity-${candidateActivity.id}`}
              candidateActivity={candidateActivity}
            />
          ))}
        </TableBody>
      </Table>
      {total > PAGE_SIZE && (
        <Pagination
          page={page}
          pageSize={PAGE_SIZE}
          total={total}
          onPageChange={setPage}
        />
      )}
    </>
  )
}

export default ActivityLog

const ActivityRow = ({ candidateActivity, ...props }) => {
  const {
    content,
    activity_points: activityPoints,
    created_at,
  } = candidateActivity || {}
  const { activity_text: eventName } = content || {}
  const formatTime = useFormatTime()
  return (
    <TableRow
      {...props}
      className="odd:bg-white even:bg-[#e2e2e2] even:bg-opacity-[29%]"
    >
      <TableCell>{eventName}</TableCell>
      <TableCell>{activityPoints}</TableCell>
      <TableCell>{formatTime(created_at)}</TableCell>
    </TableRow>
  )
}

const ActivityHeading = () => {
  const { t } = useTranslation('ActivityLog')
  const cells = [t('event_name'), t('points'), t('date')]
  return (
    <TableHeader className="h-6 bg-intoo-blue-medium">
      <TableRow className="text-lg text-white hover:bg-intoo-blue-medium">
        {cells.map((cell, index) => (
          <TableHead key={index} className="font-medium text-white">
            {cell}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
